import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { withLayout } from "../../../components/layout/Layout";
import { isSBProvisionedWithoutProfiles } from "../../../store/account";
import { ProtectionChoicePageForProvisioned } from "./ProtectionChoicePageForProvisioned";
import { ProtectionChoicePageForNonProvisioned } from "./ProtectionChoicePageForNonProvisioned";
import { AriaPageTitle } from "../../../components/ariaPageTitle";

import "./ProtectionChoicePage.scss";

const ProtectionChoicePageComponent = () => {
  const isProvisionedButNeedsConfiguration = useSelector(
    isSBProvisionedWithoutProfiles
  );

  return (
    <div className={"protection-choice"}>
      <AriaPageTitle pageKey="page_title_wizard_protection_choice_page" />
      <h1 className={"protection-choice__title"}>
        <FormattedMessage id={"wizard_protection_choice_heading"} />
      </h1>
      <div className="row protection-choice__content">
        {isProvisionedButNeedsConfiguration ? (
          <ProtectionChoicePageForProvisioned />
        ) : (
          <ProtectionChoicePageForNonProvisioned />
        )}
      </div>
    </div>
  );
};

export const ProtectionChoicePage = withLayout({
  showHeaderUnderline: true,
  showNavigation: false,
  showUserInfo: false,
  showLogOutLink: true,
})(ProtectionChoicePageComponent);
